import type {SizeUnits} from '@PosterWhiteboard/libraries/resize-poster.library';
import type {PosterTypeObject} from '@PosterWhiteboard/poster-type/poster-type.types';

export interface ResizeData {
  isCustomDimension: boolean;
  posterType?: PosterTypeObject;
}

export interface CopyAndResizeCTAPropItem extends ResizeData {
  isRotated: string;
}

export const enum Orientation {
  LANDSCAPE = 'Landscape',
  PORTRAIT = 'Portrait',
}

export type CopyAndResizeData = Array<CopyAndResizeCTAPropItem>;

export interface SubItemsData {
  id: string;
  text: Orientation;
  isSelected: boolean;
}

export interface UnsavedCustomDimension {
  width: number;
  height: number;
  units: SizeUnits;
}

export interface ResizeModalPosterInformation {
  posterType?: string;
  posterDimensionText: string;
}

export const POSTER_CUSTOM_PRINT = 'poster-custom-print';
export const POSTER_CUSTOM = 'poster-custom';
export const CATEGORY_FILTER_LIST_ID = 'resize-poster-category-filter-list';

export interface ResizeCategory {
  id: string;
  labelKey: string;
  // Fed to the same fuzzy search a user typing this word would trigger; matched against poster-type keywords.
  searchTerm: string;
  icon: string;
}

// Frontend-defined mobile filter pills. Selecting one shows the exact results of searching its `searchTerm`.
export const RESIZE_CATEGORIES: ResizeCategory[] = [
  {id: 'instagram', labelKey: 'pmwjs_instagram', searchTerm: 'instagram', icon: 'icon-instagram'},
  {id: 'print', labelKey: 'pmwjs_print', searchTerm: 'print', icon: 'icon-print'},
  {id: 'document', labelKey: 'pmwjs_document', searchTerm: 'document', icon: 'icon-doc'},
  {id: 'digital', labelKey: 'pmwjs_digital', searchTerm: 'digital', icon: 'icon-tv'},
  {id: 'facebook', labelKey: 'pmwjs_facebook', searchTerm: 'facebook', icon: 'icon-facebook'},
  {id: 'menu', labelKey: 'pmwjs_menu', searchTerm: 'menu', icon: 'icon-food-menu'},
];
